import React from 'react';
import PropTypes from 'prop-types';
import pageComponentMap from './pageComponentMap';
import get from 'lodash/get';
import withAnchor from '../components/Anchor/withAnchor';

const PageComponentFactory = ({
  latestUpdateTime,
  pageContent,
  serviceData,
  pageMetaDataConfig
}) => {
  const PageComponent = pageComponentMap.get(pageContent?.key) || (() => <></>);
  const anchor = get(pageContent, 'anchor', null);

  const componentProps = {
    ecmContent: pageContent,
    serviceData,
    pageMetaDataConfig,
    latestUpdateTime
  };

  if (anchor) {
    const AnchoredPageComponent = withAnchor(PageComponent);
    return <AnchoredPageComponent {...componentProps} anchor={anchor} />;
  }
  return <PageComponent {...componentProps} />;
};

PageComponentFactory.propTypes = {
  pageContent: PropTypes.object,
  serviceData: PropTypes.object.isRequired,
  pageMetaDataConfig: PropTypes.object.isRequired
};
PageComponentFactory.defaultProps = {
  pageContent: null
};

export default PageComponentFactory;
